class AdditionallyClass {
    constructor() {
        this.id = this.generateId();
        this.name = '';
        this.value = '';
        this.unit = '';
    }

    generateId() {
        return 'id_' + Math.random().toString(36).substr(2, 9);
    }

    toPlainObject() {
        return {
            id: this.id,
            name: this.name,
            value: this.value,
            unit: this.unit,
            isNew: true,
        };
    }
}

export default AdditionallyClass;
